module.exports = __webpack_public_path__ + "img/kayak002.9f69de7d.jpg";